import { render, staticRenderFns } from "./TrackerEdit.vue?vue&type=template&id=070f541c&scoped=true&"
import script from "./TrackerEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f541c",
  null
  
)

export default component.exports